import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../../Firebase';
import "./ReceivedCapsules.css";
import ReceivedCardCarousel from '../../Card/ReceivedCardCarousel';
import PropTypes from 'prop-types';
import Fade from '@material-ui/core/Fade';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from "react-responsive-modal";
import ScopeModal from '../../Challenge/ScopeModal';
import confirmationDesktop from '../../../assets/confirmation_v2.svg';

class ReceivedCapsules extends Component {

  render() {
    return (
      <ReceivedCapsulesComponent {...this.props} />
    );
  }
}

const INITIAL_STATE = {
  myAssignments: [],
  selectedAssignment: null,
  error: null,
  currentUserInfos: null,
  uid: '',
  calendarOpen: false,
  loading: true,
  assignmentDiffusion: { capsuleId: '' },
  scopeTeam: false,
  scopePeer: false,
  managers: [],
  confirmationOpen: false,
  imageLoading: false,
};

const styles_loader = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  button: {
    margin: theme.spacing.unit * 2,
  },
  progress: {
    color: '#0070A2',
  },
  placeholder: {
    height: 40,
  },
  buttonProgress: {
    color: '#0070A2',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -20,
    marginLeft: -12,
  },
});


class ReceivedCapsulesComponentBase extends Component {

  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE, scopeOpen: false, creationLoading: false, };
  }

  async componentDidMount() {

    document.body.style.background = '#F8F9FB';

    let querySnapshotCapsules = await this.props.firebase.db.collection('capsules').get() //a terme ceci sera trop gros (requete sur toutes les entreprises)

    this.props.firebase.auth.onAuthStateChanged(async (user) => {

      if (user === null) {
        return
      }
      this.props.refreshTopBar(user)

      let querySnapshotAssignments = await this.props.firebase.db.collection('assignments')
        .where('targetUser', '==', user.uid)
        .get()

      let myAssignments = querySnapshotAssignments.docs;

      await this.props.firebase.db
        .collection("users")
        .doc(this.props.firebase.auth.currentUser.uid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            const cu = doc.data();
            this.setState({
              currentUserInfos: cu,
            });
          }
        })
        .catch((error) => {
          console.error("Error getting document:", error);
        });

      if (myAssignments.length === 0) {
        this.setState({ loading: false })
      }

      myAssignments.forEach(async (assignmentDoc) => {

        let processed = false;
        const assignment = assignmentDoc.data();

        for (const doc of querySnapshotCapsules.docs) {

          let data = doc.data();
          let capsuleId = doc.id;
          let assigneeName = doc.data().assigneeName;


          if (assignment.assignedCapsule === capsuleId && assignment.accepted === null && !assigneeName) {
            processed = true
            let updateAssignment = {
              ...assignment,
              assignmentID: assignmentDoc.id,
              capsule: data,
              capsuleTitle: data.title,
              capsulePicture: data.picture,
              capsuleTags: data.tags,
              capsulePolls: [],
              capsuleIdeas: [],
              capsuleLikes: data.nbLikes,
              capsuleAssigneeID: data.assigneeID,
              capsuleAssigneeName: data.assigneeName
            }

            let querySnapshot = await this.props.firebase.db.collection('capsules/' + capsuleId + '/polls').get()
            let pollsIds = querySnapshot.docs.map(doc => doc.id)
            updateAssignment.capsulePolls = pollsIds

            let querySnapshotIdeas = await this.props.firebase.db.collection('capsules/' + capsuleId + '/ideas').get()
            let ideasIds = querySnapshotIdeas.docs.map(doc => doc.id)
            updateAssignment.capsuleIdeas = ideasIds
            this.setState({
              myAssignments: this.state.myAssignments.concat([updateAssignment]),
              loading: false
            })
          }
        }
        if (!processed) {
          this.props.firebase.db.collection('assignments').doc(assignmentDoc.id).delete()
        }
      });
    })

  }

  removeProcessedAssignment = (assignmentID) => {

    let myAssignments = this.state.myAssignments;
    let indexToRemove = null;

    myAssignments.forEach((assignment, index) => {
      if (assignment.assignmentID === assignmentID) {
        indexToRemove = index
      }
      myAssignments.splice(indexToRemove, 1);
    })

    this.setState({
      myAssignments
    })
  }

  onAcceptCapsule = async (assignment) => {
    const timestamp = Date.now();

    const capsuleID = assignment.assignedCapsule;

    await this.props.firebase.db
      .collection('capsules')
      .doc(capsuleID).update({
        accepted: true,
        status: 'pending',
        assigneeId: this.props.firebase.auth.currentUser.uid,
        acceptanceDate: new Date().getTime(),
      })

    await this.props.firebase.db
      .collection('assignments')
      .doc(assignment.assignmentID)
      .update({
        accepted: true
      })

    this.removeProcessedAssignment(assignment.assigneeID);
    let newHistoric = { date: timestamp, firstname: this.state.currentUserInfos.firstname, lastname: this.state.currentUserInfos.lastname, picture: this.state.currentUserInfos.image_url_profile, status: "accepted" }
    await this.props.firebase.db.collection('capsules').doc(capsuleID).collection('historic').add(newHistoric)
  }

  onDeclineCapsule = async (assignment) => {

    await this.props.firebase.db
      .collection('assignments')
      .doc(assignment.assignmentID)
      .update({
        accepted: false
      })

    this.removeProcessedAssignment(assignment.assignmentID);
  }

  handleChange = () => {
    this.setState(state => ({
      checked: !state.checked
    }))
  }

  openScope = (assignmentDiffusion) => {
    this.setState({
      assignmentDiffusion: assignmentDiffusion,
      scopeOpen: true
    })
  }

  closeScope = () => {
    this.setState({
      scopeOpen: false,
    })
  }

  setScope = (peer, team) => {
    this.setState({
      scopePeer: peer,
      scopeTeam: team
    })
  }

  onDiffusion = (scopePeer, scopeTeam) => {
    this.setState({ creationLoading: true });
    let currentManagers = this.state.assignmentDiffusion.capsule.managers
    if (scopeTeam) {
      if (!currentManagers.includes(this.props.firebase.auth.currentUser.uid))
        currentManagers.push(this.props.firebase.auth.currentUser.uid)
    }
    if (scopePeer) {
      if (!currentManagers.includes(this.state.currentUserInfos.manager))
        currentManagers.push(this.state.currentUserInfos.manager)
    }
    this.props.firebase.db.collection('capsules').doc(this.state.assignmentDiffusion.assignedCapsule).update({ managers: currentManagers }).then(() => {
      this.closeScope();
      this.openConfirmation();
      this.setState({ creationLoading: false })
    })
  }

  openConfirmation = () => {
    this.setState({
      confirmationOpen: true,
      imageLoading: true
    })
  }

  closeConfirmation = () => {
    this.setState({
      confirmationOpen: false
    })
  }

  onLoadImage = () => {
    this.setState({ imageLoading: false })
  }

  render() {
    const { classes } = this.props;
    const { loading, myAssignments, creationLoading, imageLoading, } = this.state;

    return (
      <>
        <div className="row received-title-container">
          <div className="col received-title">
            <div className={classes.root}>
              <div className={classes.placeholder}>
                <Fade
                  in={loading}
                  style={{
                    transitionDelay: loading ? '0ms' : '0ms',
                  }}
                  unmountOnExit

                >

                  <CircularProgress className={classes.progress} />
                </Fade>
              </div>
            </div>
            {loading ? null : (Object.keys(myAssignments).length > 0 ? 'Vous avez reçu de nouvelles capsules, que souhaitez-vous faire ?' : "Vous n'avez pas de nouvelle capsule")}
          </div>
        </div>

        <div className="col">
          <div className="received-carousel-container">
            <Fade
              in={loading === false}>
              <div>
                <ReceivedCardCarousel
                  data={myAssignments}
                  onAcceptCapsule={this.onAcceptCapsule}
                  onDeclineCapsule={this.onDeclineCapsule}
                  onDiffusionCapsule={this.openScope}
                  direction={'down'}
                />
              </div>

            </Fade>
          </div>
        </div>
        <Modal
          open={this.state.scopeOpen}
          onClose={this.closeScope}
          center
          showCloseIcon={true}
          styles={(window.innerWidth > 768) ? styles_desktop : styles_mobile}
        >
          <ScopeModal
            onClose={this.closeScope}
            setScope={this.setScope}
            creationLoading={creationLoading}
            addDiffusion={this.onDiffusion}
            diffusion={true}
          />
        </Modal>
        <Modal
          open={this.state.confirmationOpen}
          onClose={this.closeConfirmation}
          center
          showCloseIcon={true}
          classNames={{ 'closeButton': 'closeIconModal' }}
          styles={styles_confirmation}
          closeIconSvgPath={<path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z" fill="#FFFFFF"></path>}
        >
          {imageLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
          <img src={confirmationDesktop} className="h-100 w-100 p-0 object-fit-cover" onLoad={this.onLoadImage} alt="confirmation" />

        </Modal>
      </>
    );
  };
}

ReceivedCapsulesComponentBase.propTypes = {
  classes: PropTypes.object.isRequired,
};


const styles_desktop = {
  overlay: {
    display: "block",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.79)",
    overflow: "auto",
  },
  modal: {
    boxShadow: 'none',
    borderRadius: '4px',
    minHeight: "541px",
    maxWidth: "376px",
    top: "10%",
    padding: "0px",
  }
};

const styles_mobile = {
  overlay: {
    display: "block",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.79)",
    overflow: "auto",
    padding: "0px",
  },
  modal: {
    boxShadow: 'none',
    minHeight: "100%",
    width: "100%",
    padding: "0px",
  }
};

const styles_confirmation = {
  overlay: {
    display: "block",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 9999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.79)",
    overflow: "auto",
    padding: "0px",
  },
  modal: {
    width: (window.innerWidth > 768) ? '20vw' : '80vw',
    background: "rgba(0,0,0,0)",
    top: '20vh',
    padding: "0px"
  }
};

const ReceivedCapsulesComponent = withRouter(withFirebase(withStyles(styles_loader)(ReceivedCapsulesComponentBase)));

export default ReceivedCapsules;
export { ReceivedCapsulesComponent };